var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "从素材库选择图片",
        width: 960,
        maskClosable: false,
        footer: null,
      },
      on: { cancel: _vm.handleClose },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: false } },
        [
          _c("media-grid", {
            ref: "grid",
            attrs: {
              selectable: true,
              multiple: _vm.multiple,
              limit: _vm.limit,
            },
            on: {
              pick: _vm.onPickSingle,
              "selection-change": _vm.onSelectionChange,
            },
          }),
          _vm.multiple
            ? _c(
                "div",
                { staticClass: "picker-footer" },
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-right": "12px" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: !_vm.selectedItems.length,
                      },
                      on: { click: _vm.confirmSelect },
                    },
                    [
                      _vm._v(
                        "\n        确认选择 " +
                          _vm._s(
                            _vm.selectedItems.length
                              ? _vm.selectedItems.length + " "
                              : ""
                          ) +
                          "项\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }